var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSzukajGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #65b794;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Uploaded_to_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,2C6,2,2,6,2,11s4,9,9,9,9-4,9-9S16,2,11,2ZM11,19c-4.4,0-8-3.6-8-8S6.6,3,11,3s8,3.6,8,8-3.6,8-8,8ZM21.3,18.7l-.3.3-1.3-1.3c1.7-2.2,2.6-5.2,2.2-8.3C21.2,4.7,17.5.9,12.8.1,5.3-1.1-1.1,5.3.1,12.8c.8,4.7,4.6,8.4,9.2,9,3.2.5,6.1-.4,8.3-2.2l1.3,1.3-.3.3c-.4.4-.4,1,0,1.4l7.3,7.3c1.1,1.1,2.9,1.1,4,0h0c1.1-1.1,1.1-2.9,0-4l-7.3-7.3c-.4-.4-1-.4-1.4,0ZM1,11C1,5.5,5.5,1,11,1s10,4.5,10,10-4.5,10-10,10S1,16.5,1,11ZM18.5,19.1c.2-.2.4-.4.6-.6l1.2,1.2-.6.6-1.2-1.2ZM19.4,22l2.6-2.6,7.3,7.3c.7.7.7,1.9,0,2.6h0c-.7.7-1.9.7-2.6,0l-7.3-7.3Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzukajGreen);
export default __webpack_public_path__ + "static/media/szukaj_green.c5ee808dfebce6a9052bfabe5d9ed00e.svg";
export { ForwardRef as ReactComponent };